import { MetadataClient } from '@mae/client-web/metadata-client';
import { themeSettingsStore } from '@mae/components/themes/theme-settings-store';
import { i18NextStore } from '@mae/localization';
import { Branding } from '@mae/mvc-studio/utils/branding';
import { Theming } from '@mae/mvc-studio/utils/theming';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { getParametersByName, fetchAssets } from './utils';

import '@mae/fonts/open-sans'; //TODO: on update editor VS runtime: move this to editor only
import './style/main.scss';
import './gl-customization/style.scss';

class Main {
	constructor(containerSelector = 'multi-viewer-container') {
		this.init(document.querySelector(containerSelector));
	}

	async init(container: Element) {
		const tenant = getParametersByName('tenant');
		const appId = getParametersByName('appId');
		const edit = getParametersByName('edit') == 'true';
		const storage = edit ? 'studio_storage' : 'apps_storage';

		themeSettingsStore.initialize();

		MetadataClient.initialize(storage, tenant);

		if (MetadataClient.hasToken()) {
			themeSettingsStore.setPrimaryColor(MetadataClient.getToken().primaryColor);
			themeSettingsStore.setSecondaryColor(MetadataClient.getToken().secondaryColor);
		}

		await i18NextStore.init().then((store) => {
			const direction = store.I18n.dir();
			document.dir = direction;
			themeSettingsStore.setTextDirection(direction);
		});

		fetchAssets(edit ? 'studio_storage' : 'apps_storage', tenant);
		if (edit) {
			Branding.setBrandingColors();
		}
		Theming.appendThemeFile();

		import('./multi-viewer').then((MultiViewerComponent) => {
			ReactDOM.render(
				React.createElement(MultiViewerComponent.default, { tenant: tenant, appId: appId, edit: edit }, null),
				container
			);
		});
	}
}

new Main();
